var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.79288 19.6213L2.29288 13.1213C1.90237 12.7308 1.90237 12.0976 2.29288 11.7071L3.70706 10.2929C4.09757 9.90233 4.73077 9.90233 5.12128 10.2929L9.5 14.6716L18.8787 5.29288C19.2692 4.90237 19.9024 4.90237 20.2929 5.29288L21.7071 6.7071C22.0976 7.09761 22.0976 7.73077 21.7071 8.12132L10.2071 19.6214C9.81655 20.0119 9.18339 20.0119 8.79288 19.6213Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.e4bd24a4371926aa21ecb03fe797f476.svg";
export { ForwardRef as ReactComponent };